module.exports = __webpack_public_path__ + "img/c5_m.607df33b.png";